import { ToastActionType } from './enums.ts';
import type { Toast, ToastProperties, ToastReduxState } from './types.ts';
import { removeValueMatching } from '../../utils/immutable/array/removeValueMatching.ts';
import { replaceValue } from '../../utils/immutable/array/replaceValue.ts';
import { replaceValueMatching } from '../../utils/immutable/array/replaceValueMatching.ts';
import type { ReduxAction, ReduxReducer } from '../types.ts';

function addToast(state: ToastReduxState, { message, color, id, state: toastState }: Toast): ToastReduxState {
  return {
    ...state,
    toasts: replaceValueMatching(
      state.toasts ?? [],
      toast => toast.id === id,
      { message, color, id, state: toastState }
    )
  };
}

function updateToast(state: ToastReduxState, { id, state: toastState }: Toast): ToastReduxState {
  const toast = state.toasts?.find((toast: ToastProperties) => toast.id === id);

  return ({
    ...state,
    toasts: toast
      ? replaceValue(state.toasts ?? [], toast, { ...toast, state: toastState })
      : []
  });
}

function clearToast(state: ToastReduxState, { id }: Toast): ToastReduxState {
  return ({
    ...state,
    toasts: removeValueMatching(state.toasts ?? [], (toast: ToastProperties) => toast.id === id)
  });
}

 
const reducers: Record<ToastActionType, ReduxReducer<ToastReduxState, Toast>> = {
  [ToastActionType.Add]: addToast,
  [ToastActionType.Clear]: clearToast,
  [ToastActionType.Update]: updateToast
};

export function toasts(state: ToastReduxState = {}, action: ReduxAction): ToastReduxState {
  return (
    action.type in reducers
      ? reducers[action.type as ToastActionType]
      : (state: ToastReduxState) => state
  )(state, action);
}